<template lang='pug'>
  div
    v-tooltip(bottom v-if='isRunning')
      template(v-slot:activator='{on}')
        bionic-metrics-running-indicator-circular(v-on='on')
      span Running
    div(v-if='!isRunning')
      v-tooltip(v-if="status === 'NO_DATA'" bottom)
        template(v-slot:activator='{on}')
          v-icon(v-on='on' :size='size') remove
        span No Data
      v-tooltip(v-if="status === 'CANCELLED' || status === 'INCOMPLETE'" bottom)
        template(v-slot:activator='{on}')
          v-icon(v-on='on' :size='size') remove_circle_outline
        span Cancelled or Incomplete
      v-tooltip(v-if="status === 'PASSING'" bottom)
        template(v-slot:activator='{on}')
          v-icon(v-on='on' :size='size' color='success') check_circle
        span Passing
      v-menu(offset-y left v-if="status === 'FAILING' && retriable")
        template(v-slot:activator='{on:menu}')
          v-tooltip(bottom)
            template(v-slot:activator='{on:tooltip}')
              v-icon(v-on='{...tooltip, ...menu}' color='error') cancel
            span Failing
        v-list
          v-list-item(@click='retryFailed()')
            v-list-item-title
              | Retry Failed Tests
      v-tooltip(v-if="status === 'FAILING' && !retriable" bottom)
        template(v-slot:activator='{on}')
          v-icon(v-on='on' :size='size' color='error') cancel
        span Failing
      v-tooltip(v-if="status === 'FAULT'" bottom)
        template(v-slot:activator='{on}')
          v-icon(v-on='on' :size='size' color='error') remove_circle_outline
        span Fault
</template>

<script>
import TestRun from '@/api/testRun';
import Notifications from '@/services/notification.service';
import BionicMetricsRunningIndicatorCircular from '@/components/RunningIndicatorCircular';

export default {
  name: 'BionicMetricsTestStatusIndicator',
  components: {BionicMetricsRunningIndicatorCircular},
  props: {
    status: {
      type: String,
      default: 'NO_DATA'
    },
    isRunning: {
      type: [Boolean, Number],
      default: false
    },
    size: {
      type: Number,
      default: 24
    },
    testSuite: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    retriable() {
      return this.testSuite && (this.testSuite.continueOnFail || this.testSuite.parallel);
    }
  },
  methods: {
    async retryFailed() {
      await TestRun.retryFailed(this.testSuite.runGuid);
      this.$emit('retryFailed', this.testSuite);
      Notifications.toast(`Retrying Failed Tests for for ${this.testSuite.name}`);
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
